/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var Widget     = require('spa-component-widget'),
    ModMes     = require('mag-component-modal'),
    LayoutList = require('mag-component-layout-list'),
    keys       = require('stb-keys'),
    app        = require('mag-app'),
    message,
    lastInitData = [],
    widget = new Widget({
        $node: document.getElementById('modalIntentWidget'),
        //visible: true,
        events: {
            show: function () {
                message.focus();
            },
            hide: function () {
                if ( app.lastFocus ) {
                    app.lastFocus.focus();
                }
            }
        }
    });

widget.add(
    message = new ModMes({
        visible: true,
        title: gettext('Actions'),
        children: [
            widget.list = new LayoutList({
                data: [],
                size: 0,
                events: {
                    'click:item': function () {
                        widget.hide();
                    },
                    keydown: function ( event ) {
                        if ( event.code === keys.back ||  event.code === keys.menu ) {
                            event.stop = true;
                            widget.hide();
                        } else {
                            LayoutList.prototype.defaultEvents.keydown.call(this, event);
                        }
                    }
                }
            })
        ]
    })
);


widget.init = function ( data ) {
    var menuData = [];

    lastInitData = data;

    data.forEach(function (elem) {
        menuData.push({
            items: [
                {
                    className: 'theme-icon theme-icon-rc-' + ( elem.icon || ''),
                    value: ''
                },
                {
                    className: 'title',
                    value: elem.title
                }
            ],
            click: elem.handler
        });
    });
    widget.list.init({
        data: menuData,
        size: menuData.length,
        focusIndex: 0
    });

};

// superhardcode
app.addListener('keydown', function ( event ) {
    if ( event.code === keys.f1 ) {
        if ( widget.record && lastInitData[0].handler ) {
            lastInitData[0].handler();
            widget.hide();
        }
    }
});

module.exports = widget;
